import { LogoIcon } from '@lichtblick/icons/svg/logo/logo';
import { DurationAndEasing } from '@lichtblick/theme';
import styled from 'styled-components';
export const Logo = styled(LogoIcon)`
  [class*='logo-sun'] {
    transition: transform ${DurationAndEasing.SmallIntro};

    *:focus-visible > &,
    *:hover > & {
      transform: translate(0.25rem, -0.125rem);
    }

    *:active > & {
      transform: translate(0.625rem, -0.3125rem);
    }
  }
`;

//# sourceMappingURL=Logo.js.map